module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pFrontFlap"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2020")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2019 by Bill Pennington")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "https://www.hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Names: Pennington, Bill, 1956– author.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Title: Chumps to champs : how the worst teams in Yankees history led to the 90’s dynasty / Bill Pennington.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Description: Boston : Houghton Mifflin Harcourt, [2019] | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Identifiers: LCCN 2018046434 (print) | LCCN 2018051095 (ebook) | ISBN 9781328849878 (ebook) | ISBN 9781328849854 (hardback) | ISBN 9780358331834 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Subjects: LCSH: New York Yankees (Baseball team)—History—20th century. | Baseball players—New York (State)—New York—Biography. | Baseball managers—New York (State)—New York—Biography. | BISAC: SPORTS & RECREATION / Baseball / History. | HISTORY / United States / State & Local / Middle Atlantic (DC, DE, MD, NJ, NY, PA).")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Classification: LCC GV875.N4 (ebook) | LCC GV875.N4 P45 2019 (print) | DDC 796.357/64097471—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2018046434",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018046434")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover design by Mark R. Robinson")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover photograph (top) © Douglas C. Pizac / Associated Press; (bottom) © Linda Cataffo / "), _c('em', [_vm._v("New York Daily News")]), _vm._v(" Archive")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Author photograph © Nina Subin")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("v2.0320")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2081d925","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0